import {makeObservable, observable, runInAction} from "mobx";
import {notification} from "antd";
import {request} from "@/framework/network/request";
import Product from "@home/model/Product";
import {BaseProductModel} from "@/components/ProductList/BaseProductList";


export default class MerchantMallStore {
  loading: boolean
  cardShow: boolean //商品显示模式
  productList: BaseProductModel[] // 商品列表
  pagination: any
  search: any // 商品查询

  constructor() {
    makeObservable(this, {
      loading: observable,
      cardShow: observable,
      productList: observable,
      search: observable,
    })
    this.loading = false;
    this.cardShow = true;
    this.productList = [];
    this.pagination = {
      pageSizeOptions: ['2', '10', '20', '30', '50'],
      showSizeChanger: false,
      showQuickJumper: true,
      showTotal: (total: string) => `共 ${total} 条记录`
    }
    this.search = {}

  }


  // 商品列表
  getItemsList = async (page: number = 0, size: number = 20) => {
    try {
      this.loading = true
      const res = await request.get(`/public/products`, {...this.search, size, page})
      runInAction(() => {
        this.productList = res.data?.content?.map((item: Product) => {
          return {
            ...item,
            id: item.id,
            title: item.name,
            price: item.minPrice,
            titleFile: item.picture,
          }
        })
        this.pagination = {
          ...this.pagination,
          total: res.data.totalElements,
          current: res.data.number + 1,
          pageSize: res.data.size,
        }
        this.loading = false
      })
    }catch (e) {
      this.loading = false
      notification.error({
        message: '获取商品信息错误',
        description: e.message
      })
    }
  }

  setCardShow = (flag: boolean) => {
    this.cardShow = flag
  }

  setSearch = (values: any) => {
    this.search = values
  }

}